// German translations
const de = {
  common: {
    appName: "Protego",
    subtitle: "Globales Compliance-Prüfungstool",
    footer: "Alle Rechte vorbehalten",
    search: "Suchen",
    profile: "Profil",
    admin: "Admin",
    loading: "Wird geladen...",
    welcome: "Hallo",
    error: "Fehler",
    success: "Erfolg",
    save: "Speichern",
    cancel: "Abbrechen",
    edit: "Bearbeiten",
    delete: "Löschen",
    close: "Schließen",
    back: "Zurück",
    next: "Weiter",
    submit: "Absenden",
    download: "Herunterladen",
    monitor: "Überwachen",
    confirm: "Bestätigen",
    processing: "Verarbeitung...",
    completed: "Abgeschlossen",
    generating: "Wird generiert...",
    retry: "Wiederholen",
    unknown: "Unbekannt",
    yes: "Ja",
    no: "Nein",
    view: "Ansehen",
    copyLink: "Link kopieren",
    copied: "Kopiert!",
    backToSearch: "Zurück zur Suche",
    backToCases: "Zurück zu Fällen",
    backToReport: "Zurück zum Bericht",
    backToHistory: "Zurück zur Historie",
    backToMonitoring: "Zurück zur Überwachung",
    organization: "Organisation",
    active: "Aktiv",
    saving: "Speichern..."
  },
  welcomeSection: {
    advancedSearch: {
      title: "Erweiterte Suche",
      description: "Intelligente Algorithmen zum Namensabgleich erkennen Variationen in Schreibweise und Struktur."
    },
    confidenceScoring: {
      title: "Vertrauensbewertung",
      description: "Ergebnisse werden mit detaillierten Konfidenzleveln eingestuft, um relevante Übereinstimmungen zu identifizieren."
    },
    complianceReady: {
      title: "Konformitätsbereit",
      description: "Erstellen Sie Verifizierungsberichte mit eindeutigen IDs für die behördliche Compliance."
    }
  },
  search: {
    placeholder: "Namen zur Überprüfung gegen Sanktionslisten eingeben...",
    button: "Suchen",
    advancedOptions: "Erweiterte Optionen",
    noResults: "Keine Ergebnisse gefunden",
    resultsCount: "{{count}} Ergebnisse gefunden",
    entityType: "Entitätstyp",
    personType: "Personen",
    enterpriseType: "Firmen",
    confidence: {
      veryHigh: "Sehr Hoch",
      high: "Hoch",
      medium: "Mittel",
      low: "Niedrig"
    },
    searching: "Sanktionslisten werden durchsucht...",
    loading: "Wird geladen...",
    scanningRecords: "Datenbankeinträge werden gescannt",
    processed: "Verarbeitet",
    of: "von",
    records: "Einträgen",
    searchResults: "Suchergebnisse",
    foundMatches: "{{count}} Übereinstimmungen für \"{{term}}\" gefunden",
    showingTop: "Zeige die besten {{shown}} von insgesamt {{total}} Übereinstimmungen (nach Relevanz sortiert)",
    all: "Alle",
    riskMatch: "Risikoübereinstimmung",
    veryHighRiskMatch: "Sehr Hohe Risikoübereinstimmung",
    highRiskMatch: "Hohe Risikoübereinstimmung",
    mediumRiskMatch: "Mittlere Risikoübereinstimmung",
    lowRiskMatch: "Niedrige Risikoübereinstimmung",
    filters: {
      all: "Alle",
      veryHigh: "Sehr Hoch",
      high: "Hoch",
      medium: "Mittel",
      low: "Niedrig"
    },
    caseStatus: "Fallstatus",
    caseStatusPending: "Überprüfung ausstehend",
    caseStatusPartial: "Teilweise überprüft",
    caseStatusCompleted: "Überprüfung abgeschlossen",
    includeDismissed: "Abgelehnte einbeziehen",
    searchId: "Such-ID",
    name: "Name",
    companyName: "Firmenname"
  },
  results: {
    noSanctionsFound: "Keine Sanktionen gefunden",
    cleared: "erscheint auf keiner Sanktionsliste. Diese Person wurde gegen alle überwachten Sanktionsdatenbanken überprüft.",
    clearedEntity: "erscheint auf keiner Sanktionsliste. Diese Entität wurde gegen alle überwachten Sanktionsdatenbanken überprüft.",
    individualCleared: "Diese Person wurde gegen alle überwachten Sanktionsdatenbanken überprüft.",
    companyCleared: "Dieses Unternehmen wurde gegen alle überwachten Sanktionsdatenbanken überprüft.",
    verificationId: "Verifizierungs-ID",
    recordsScanned: "Gescannte Einträge",
    searchTimestamp: "Suchzeitstempel",
    downloadPdfReport: "PDF-Bericht herunterladen",
    addToMonitoring: "Zur Überwachung hinzufügen",
    removeFromMonitoring: "Von Überwachung entfernen",
    sourcesChecked: "Überprüfte Quellen",
    financialSanctions: "Finanzsanktionen",
    travelBans: "Reiseverbote",
    unSanctions: "UN-Sanktionen",
    databaseChecked: "Datenbank überprüft",
    disclaimer: "Dieses Prüfergebnis ist eine Momentaufnahme und garantiert keinen zukünftigen Compliance-Status.",
    legalNote: "Für Compliance-Zwecke sollten Sie eine Kopie dieses Berichts aufbewahren.",
    generatingPdf: "PDF-Bericht wird generiert...",
    scoreBreakdown: "Ergebnis-Aufschlüsselung",
    tokenMatch: "Token-Übereinstimmung",
    positional: "Positionswert",
    transliteration: "Transliteration",
    distributedMatchBoost: "Verteilte Übereinstimmungserhöhung",
    culturalPattern: "Kulturelles Muster",
    distributedNameMatch: "Übergreifender Namensabgleich",
    crossMatchExplanation: "Suchtext \"{{term}}\" wurde über verschiedene Namensvarianten hinweg gefunden. Der Suchbegriff wurde auf diese Namen verteilt:",
    matchedVariants: "Übereinstimmende Varianten",
    sanctionsDetails: "Sanktionsdetails",
    category: "Kategorie",
    program: "Programm",
    listingDate: "Listungsdatum",
    lastUpdated: "Zuletzt aktualisiert",
    documents: "Dokumente",
    sanctionsReport: "Bericht über Sanktionsprüfung",
    clearanceReport: "Freigabebericht",
    issuedBy: "Ausgestellt von",
    issuedByValue: "Protego",
    expiry: "Gültig bis",
    reportTimestamp: "Bericht erstellt",
    searchDate: "Suchdatum",
    validUntil: "Gültig bis",
    sanctionType: "Sanktionstyp",
    issueDate: "Ausstellungsdatum",
    country: "Land",
    moreDetails: "Weitere Details",
    generatingPdfReport: "PDF-Bericht wird generiert",
    citizenship: "Staatsbürgerschaft",
    alternativeNames: "Alternative Namen",
    documentId: "Dokument-ID",
    viewOnEUSanctionsTracker: "Im EU-Sanktionsverfolger anzeigen",
    viewOnUNSecurityCouncilSanctionsList: "Auf der Sanktionsliste des UN-Sicherheitsrats anzeigen",
    function: "Funktion / Position",
    fuzzy: "ungenaue Übereinstimmung",
    dismiss: "Zurückweisen",
    confirmMatch: "Übereinstimmung bestätigen",
    confirmed: "Bestätigt",
    dismissed: "Zurückgewiesen",
    confirmDismiss: "Als falsch positive markieren?",
    dismissExplanation: "Dies wird das Ergebnis als zurückgewiesen kennzeichnen und als falsch positiv in Ihrem Fallmanagementsystem vermerken.",
    undoReview: "Entscheidung rückgängig machen",
    runBy: "Ausgeführt von"
  },
  report: {
    title: "Screening-Bericht",
    subjectInformation: "Subjektinformationen",
    name: "Name",
    generated: "Bericht erstellt",
    screeningDetails: "Screening-Details",
    authoritiesChecked: "Geprüfte Behörden",
    verification: "Verifizierung",
    issuedBy: "Ausgestellt von",
    issuedByValue: "Protego",
    verifyAt: "Verifizieren unter",
    verificationDisclaimer: "Dieser Bericht ist eine Momentaufnahme und garantiert nicht den zukünftigen Compliance-Status.",
    generatedOn: "Erstellt am",
    verificationId: "Verifizierungs-ID",
    runBy: "Ausgeführt von"
  },
  authorities: {
    euCommission: "European Commission",
    euCommissionDescription: "Finanzsanktionen, Reiseverbote",
    unitedNations: "United Nations",
    unitedNationsDescription: "Sicherheitsrat-Sanktionen"
  },
  auth: {
    login: "Anmelden",
    signup: "Registrieren",
    logout: "Abmelden",
    welcomeBack: "Willkommen zurück",
    email: "E-Mail",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    forgotPassword: "Passwort vergessen?",
    resetPassword: "Passwort zurücksetzen",
    resetPasswordPrompt: "Geben Sie Ihre E-Mail-Adresse ein, um einen Link zum Zurücksetzen des Passworts zu erhalten",
    sendResetLink: "Zurücksetzungslink senden",
    backToLogin: "Zurück zur Anmeldung",
    alreadyHaveAccount: "Haben Sie bereits ein Konto?",
    dontHaveAccount: "Haben Sie noch kein Konto?",
    createAccount: "Konto erstellen",
    loginNow: "Melden Sie sich an, um mit dem Sanktionsprüfer fortzufahren",
    enterEmail: "Geben Sie Ihre E-Mail ein",
    enterPassword: "Geben Sie Ihr Passwort ein",
    enterName: "Geben Sie Ihren Namen ein",
    confirmYourPassword: "Bestätigen Sie Ihr Passwort",
    passwordsDontMatch: "Passwörter stimmen nicht überein",
    accountCreated: "Konto erfolgreich erstellt!",
    accountCreatedSuccessfully: "Konto erfolgreich erstellt! Sie sind jetzt angemeldet.",
    passwordResetEmailSent: "E-Mail zum Zurücksetzen des Passworts gesendet! Überprüfen Sie Ihren Posteingang.",
    resetLinkSent: "Zurücksetzungslink an Ihre E-Mail gesendet.",
    checkEmail: "Bitte überprüfen Sie Ihre E-Mail.",
    loginError: "Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre Anmeldedaten.",
    signupError: "Kontoerstellung fehlgeschlagen. Die E-Mail-Adresse wird möglicherweise bereits verwendet.",
    resetError: "Fehler beim Senden der Zurücksetzungs-E-Mail. Bitte überprüfen Sie die E-Mail-Adresse.",
    switchToLightMode: "Zum hellen Modus wechseln",
    switchToDarkMode: "Zum dunklen Modus wechseln",
    name: "Name",
    resetPasswordInstructions: "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
    sessionExpired: "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
    or: "oder",
    continueWithGoogle: "Mit Google fortfahren",
    continueWithMicrosoft: "Mit Microsoft anmelden",
    emailVerificationRequired: "Bitte bestätigen Sie Ihre E-Mail-Adresse, bevor Sie fortfahren. Überprüfen Sie Ihren Posteingang auf einen Bestätigungslink.",
    verificationEmailSent: "Eine Bestätigungs-E-Mail wurde an Ihre E-Mail-Adresse gesendet. Bitte überprüfen Sie Ihren Posteingang und bestätigen Sie Ihre E-Mail, bevor Sie fortfahren.",
    verificationEmailResent: "Bestätigungs-E-Mail wurde erneut gesendet. Bitte überprüfen Sie Ihren Posteingang.",
    verificationRequired: "Bitte bestätigen Sie Ihre E-Mail-Adresse, um fortzufahren.",
    resendVerification: "Bestätigungs-E-Mail erneut senden",
    emailVerified: "E-Mail erfolgreich bestätigt!",
    verifyYourEmail: "Bestätigen Sie Ihre E-Mail",
    verificationInstructions: "Wir haben eine Bestätigungs-E-Mail an Ihre E-Mail-Adresse gesendet. Bitte überprüfen Sie Ihren Posteingang und klicken Sie auf den Bestätigungslink, um Ihr Konto zu aktivieren.",
    iAlreadyVerified: "Ich habe meine E-Mail bereits bestätigt",
    emailNotVerified: "Ihre E-Mail ist noch nicht bestätigt. Bitte überprüfen Sie Ihren Posteingang.",
    resendVerificationError: "Fehler beim erneuten Senden der Bestätigungs-E-Mail. Bitte versuchen Sie es später noch einmal.",
    resendIn: "Erneut senden in",
    resendCooldown: "Bitte warten Sie, bevor Sie eine weitere E-Mail anfordern.",
    loginRequired: "Bitte melden Sie sich an, um auf diese Seite zuzugreifen.",
    verificationPageTitle: "E-Mail-Bestätigung erforderlich"
  },
  orgAdmin: {
    title: "Organisationsadministration",
    subtitle: "Verwalten Sie Ihre Organisation: {{orgName}}",
    accessDenied: "Zugriff verweigert",
    accessDeniedMessage: "Sie haben keine Berechtigung, auf die Organisationsadministrationsseite zuzugreifen. Nur Organisationsadministratoren können diesen Inhalt einsehen.",
    tabs: {
      userManagement: "Benutzerverwaltung",
      organizationSettings: "Organisationseinstellungen",
      billingSubscription: "Abrechnung & Abonnement"
    },
    userManagement: {
      title: "Organisationsmitglieder",
      subtitle: "Benutzer in Ihrer Organisation verwalten",
      inviteUser: "Benutzer einladen",
      inviteNewUser: "Neuen Benutzer einladen",
      emailAddress: "E-Mail-Adresse",
      emailPlaceholder: "benutzer@beispiel.de",
      role: "Rolle",
      roles: {
        member: "Mitglied",
        admin: "Administrator"
      },
      sendInvitation: "Einladung senden",
      pendingInvitations: "Ausstehende Einladungen",
      inviteCode: "Einladungscode",
      cancelInvitation: "Einladung stornieren",
      activeMembers: "Aktive Mitglieder",
      user: "Benutzer",
      joined: "Beigetreten",
      actions: "Aktionen",
      unknown: "Unbekannt",
      confirmRemoveUser: "Sind Sie sicher, dass Sie diesen Benutzer aus der Organisation entfernen möchten?",
      userAlreadyExists: "Der Benutzer ist bereits Teil dieser Organisation",
      emailRequired: "E-Mail ist erforderlich",
      inviteUserFailed: "Benutzer konnte nicht eingeladen werden. Bitte versuchen Sie es erneut.",
      updateRoleFailed: "Benutzerrolle konnte nicht aktualisiert werden",
      cancelInviteFailed: "Einladung konnte nicht storniert werden",
      removeUserFailed: "Benutzer konnte nicht entfernt werden",
      loadUsersFailed: "Benutzer konnten nicht geladen werden",
      teamMemberLimit: {
        exceeded: "Team-Mitglieder-Limit überschritten",
        warning: "Sie haben {{current}}/{{limit}} Team-Mitglieder",
        cannotJoin: "Diese Organisation hat ihr maximales Team-Mitglieder-Limit erreicht",
        cannotInvite: "Kann keine weiteren Team-Mitglieder einladen. Upgraden Sie Ihren Plan, um mehr hinzuzufügen.",
        currentCount: "{{current}}/{{limit}} Team-Mitglieder",
        upgradeRequired: "Upgraden Sie Ihren Plan, um mehr Team-Mitglieder hinzuzufügen",
        atLimit: "Sie haben Ihr Team-Mitglieder-Limit erreicht",
        nearLimit: "Sie nähern sich Ihrem Team-Mitglieder-Limit"
      }
    },
    organizationSettings: {
      title: "Organisationseinstellungen",
      subtitle: "Globale Einstellungen Ihrer Organisation konfigurieren",
      organizationDetails: "Organisationsdetails",
      organizationName: "Organisationsname",
      domain: "Domain",
      domainCannotChange: "Domain kann nach der Erstellung der Organisation nicht geändert werden",
      defaultSearchSettings: "Standard-Sucheinstellungen",
      defaultSearchCadence: "Standard-Suchkadenz",
      defaultCadenceHelp: "Standard-Kadenz für neue Benutzer",
      timezone: "Zeitzone",
      cadenceOptions: {
        "1year": "1 Jahr",
        "6months": "6 Monate",
        "3months": "3 Monate",
        "1month": "1 Monat"
      },
      timezoneOptions: {
        "UTC": "UTC",
        "America/New_York": "Eastern Time",
        "America/Chicago": "Central Time",
        "America/Denver": "Mountain Time",
        "America/Los_Angeles": "Pacific Time",
        "Europe/London": "London",
        "Europe/Paris": "Paris",
        "Europe/Berlin": "Berlin",
        "Asia/Tokyo": "Tokyo",
        "Asia/Shanghai": "Shanghai"
      },
      saveChanges: "Änderungen speichern",
      settingsUpdated: "Einstellungen erfolgreich aktualisiert",
      settingsUpdateFailed: "Einstellungen konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut."
    },
    billing: {
      title: "Abrechnung & Abonnement",
      subtitle: "Abonnement und Abrechnungsinformationen Ihrer Organisation verwalten",
      trialActive: "Testphase aktiv",
      trialDaysRemaining: "{{days}} Tage verbleibend in Ihrer Testphase",
      trialExpired: "Ihre Testphase ist abgelaufen",
      upgradeNow: "Jetzt upgraden",
      currentSubscription: "Aktuelles Abonnement",
      plan: "Plan",
      status: "Status",
      nextBillingDate: "Nächstes Abrechnungsdatum",
      unknownPlan: "Unbekannter Plan",
      paymentRequired: "Zahlung erforderlich",
      paymentOverdue: "Ihre Abonnement-Zahlung ist überfällig. Bitte aktualisieren Sie Ihre Zahlungsmethode.",
      noActiveSubscription: "Kein aktives Abonnement",
      noSubscriptionMessage: "Ihre Organisation hat noch kein aktives Abonnement.",
      organizationUsage: "Organisationsnutzung",
      activeMembers: "Aktive Mitglieder",
      searchesThisMonth: "Suchen diesen Monat",
      activeCases: "Aktive Fälle",
      apiCallsThisMonth: "API-Aufrufe diesen Monat",
      billingActions: "Abrechnungsaktionen",
      manageSubscription: "Abonnement verwalten",
      manageSubscriptionDesc: "Zahlungsmethode aktualisieren, Rechnungen einsehen, Plan ändern",
      notAvailableDuringTrial: "Nicht verfügbar während der Testphase",
      opening: "Öffne...",
      usageAnalytics: "Nutzungsanalytik",
      usageAnalyticsDesc: "Detaillierte Nutzungsberichte und Analytik (Demnächst)",
      needHelp: "Brauchen Sie Hilfe?",
      needHelpMessage: "Wenn Sie Fragen zur Abrechnung haben oder Änderungen an Ihrem Abonnement vornehmen möchten, steht Ihnen unser Support-Team gerne zur Verfügung.",
      contactSupport: "Support kontaktieren →"
    }
  },
  profile: {
    title: "Kontoeinstellungen",
    personalInfo: "Persönliche Informationen",
    accountSettings: "Kontoeinstellungen",
    usageHistory: "Nutzungsverlauf",
    savedSearches: "Gespeicherte Suchen",
    monitoredEntities: "Überwachte Einheiten",
    apiKeys: "API-Schlüssel",
    updateProfile: "Profil aktualisieren",
    changePassword: "Passwort ändern",
    deleteAccount: "Konto löschen",
    confirmDelete: "Sind Sie sicher, dass Sie Ihr Konto löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    confirmNewPassword: "Neues Passwort bestätigen",
    passwordUpdated: "Passwort erfolgreich aktualisiert",
    profileUpdated: "Profil erfolgreich aktualisiert",
    searchHistory: "Suchverlauf",
    recentSearches: "Aktuelle Suchen",
    noSearchesYet: "Noch keine Suchen",
    searchCount: "Anzahl der Suchen",
    lastSearch: "Letzte Suche",
    monitoredSince: "Überwacht seit",
    monitoringStatus: "Überwachungsstatus",
    active: "Aktiv",
    inactive: "Inaktiv",
    apiKeyInfo: "API-Zugangsschlüssel ermöglichen die Integration mit der Sanktionsprüfer-API",
    createNewKey: "Neuen API-Zugangsschlüssel erstellen",
    keyCreated: "Neuer API-Zugangsschlüssel erstellt",
    copyKey: "Schlüssel kopieren",
    revokeKey: "Schlüssel widerrufen",
    lastUsed: "Zuletzt verwendet",
    neverUsed: "Nie verwendet",
    emailNotifications: "E-Mail-Benachrichtigungen",
    enableNotifications: "E-Mail-Benachrichtigungen für überwachte Einheiten aktivieren",
    notificationFrequency: "Benachrichtigungshäufigkeit",
    daily: "Täglich",
    weekly: "Wöchentlich",
    monthly: "Monatlich",
    savedReports: "Gespeicherte Berichte",
    downloadReport: "Bericht herunterladen",
    accountCreated: "Konto erstellt",
    lastSignIn: "Letzte Anmeldung",
    subscription: "Abonnement",
    organizationSubscription: "Organisations-Abonnement",
    organization: "Organisation",
    role: "Rolle",
    admin: "Organisations-Administrator",
    member: "Mitglied",
    manageSubscription: "Abonnement verwalten",
    subscribeNow: "Jetzt abonnieren",
    noSubscription: "Sie haben kein aktives Abonnement.",
    noOrganizationSubscription: "Ihre Organisation hat kein aktives Abonnement.",
    contactAdmin: "Wenden Sie sich an Ihren Organisationsadministrator, um Abrechnung und Abonnements zu verwalten.",
    status: "Status",
    tier: "Stufe",
    professional: "Professionell",
    starter: "Starter",
    paymentOverdue: "Zahlung überfällig",
    nextBilling: "Nächste Abrechnung",
    marketingPreferences: "Marketing-Einstellungen",
    sanctionsUpdates: "Sanktions- und Compliance-Updates",
    marketingDescription: "Erhalten Sie prioritäre Benachrichtigungen über kritische Sanktions-Updates, regulatorische Änderungen und neue Compliance-Funktionen, die Ihr Unternehmen betreffen könnten.",
    marketingOn: "Sie erhalten Marketing-Mitteilungen",
    marketingOff: "Sie erhalten keine Marketing-Mitteilungen",
    marketingEnabled: "Marketing-Benachrichtigungen aktiviert",
    marketingDisabled: "Marketing-Benachrichtigungen deaktiviert"
  },
  billing: {
    adminRequired: "Zugriff als Organisationsadministrator erforderlich"
  },
  payment: {
    success: {
      title: "Vielen Dank für Ihr Abonnement!",
      subtitle: "Willkommen bei der verbesserten Sanktionsüberprüfung",
      planActive: "Ihr Abonnement ist jetzt aktiv",
      features: "Ihr Plan beinhaltet:",
      nextRenewal: "Nächste Verlängerung",
      stayUpdated: "Bleiben Sie bei Sanktionsänderungen auf dem Laufenden",
      marketingText: "Erhalten Sie prioritäre Benachrichtigungen über kritische Sanktions-Updates, regulatorische Änderungen und neue Compliance-Funktionen, die Ihr Unternehmen betreffen könnten.",
      marketingOptIn: "Ja, ich möchte über wichtige Sanktions- und Compliance-Updates informiert werden",
      continue: "Weiter zum Dashboard",
      footerNote: "Sie können Ihr Abonnement und Ihre Einstellungen jederzeit in Ihren Kontoeinstellungen verwalten."
    }
  },
  themes: {
    light: "Heller Modus",
    dark: "Dunkler Modus"
  },
  language: {
    en: "Englisch",
    hr: "Kroatisch",
    de: "Deutsch",
    fr: "Französisch",
    switchTo: "Sprache wechseln",
    comingSoon: "Demnächst verfügbar"
  },
  cookies: {
    consent: "Diese Website verwendet Cookies, um die Benutzererfahrung zu verbessern.",
    accept: "Akzeptieren",
    deny: "Ablehnen",
    privacyPolicy: "Datenschutzrichtlinie"
  },
  errors: {
    general: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    login: "Ungültige E-Mail oder Passwort.",
    required: "Dieses Feld ist erforderlich.",
    invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    passwordMatch: "Passwörter stimmen nicht überein.",
    passwordLength: "Das Passwort muss mindestens 8 Zeichen lang sein.",
    passwordRequirements: "Passwortanforderungen:",
    passwordMinLength: "10+ Zeichen",
    passwordUppercase: "1+ Großbuchstabe",
    passwordLowercase: "1+ Kleinbuchstabe",
    passwordNumber: "1+ Zahl",
    passwordSpecial: "1+ Sonderzeichen",
    serverError: "Serverfehler. Bitte versuchen Sie es später erneut.",
    notFound: "Seite nicht gefunden",
    unauthorized: "Sie sind nicht berechtigt, diese Aktion auszuführen.",
    forbidden: "Zugriff verboten.",
    offline: "Sie scheinen offline zu sein. Bitte überprüfen Sie Ihre Verbindung.",
    timeout: "Zeitüberschreitung der Anfrage. Bitte versuchen Sie es erneut.",
    conflict: "Diese Operation hat einen Konflikt verursacht. Bitte versuchen Sie es erneut.",
    emptyResult: "Keine Ergebnisse gefunden. Bitte versuchen Sie einen anderen Suchbegriff.",
    validation: "Bitte korrigieren Sie die Fehler im Formular.",
    jobNotFound: "Der angeforderte Job wurde nicht gefunden.",
    jobAccessDenied: "Sie haben keine Berechtigung, auf diesen Job zuzugreifen.",
    noVerificationId: "Keine Verifizierungs-ID für diesen Treffer verfügbar.",
    pdfGenerationFailed: "Fehler bei der PDF-Erstellung.",
    downloadFailed: "Herunterladen der Ergebnisse fehlgeschlagen. Bitte versuchen Sie es erneut.",
    googleAuthFailed: "Google-Authentifizierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    popupClosed: "Authentifizierungsfenster wurde geschlossen. Bitte versuchen Sie es erneut.",
    accountExists: "Ein Konto mit derselben E-Mail-Adresse existiert bereits."
  },
  pdf: {
    pageOf: "Seite {{current}} von {{total}}",
    sanctionsCheckHeader: "Ergebnisse der Sanktionsprüfung",
    verified: "VERIFIZIERT",
    flagged: "MARKIERT",
    disclaimer: "HINWEIS: Dieser Bericht dient nur zu Informationszwecken und stellt keine Rechtsberatung dar. Die in diesem Bericht enthaltenen Informationen sind zum Zeitpunkt der Erstellung korrekt.",
    confidential: "VERTRAULICH - NUR FÜR AUTORISIERTE NUTZUNG"
  },
  monitoring: {
    addedSuccess: "Erfolgreich zur Überwachung hinzugefügt",
    addError: "Fehler beim Hinzufügen zur Überwachung",
    removedSuccess: "Erfolgreich von der Überwachung entfernt",
    removeError: "Fehler beim Entfernen von der Überwachung",
    missingVerificationId: "Fehlende Verifizierungs-ID für Überwachung",
    alreadyMonitored: "Diese Entität wird bereits überwacht",
    notMonitored: "Diese Entität wird nicht überwacht",
    title: "Überwachung",
    description: "Überwachen Sie Entitäten und führen Sie automatisch regelmäßige Überprüfungen durch",
    emptyMessage: "Fügen Sie Namen zur Überwachung von der Suchergebnisseite hinzu",
    noMonitoredSearches: "Keine überwachten Entitäten",
    totalMonitored: "Insgesamt überwacht",
    verificationId: "Verifizierungs-ID",
    addedOn: "Hinzugefügt am",
    lastChecked: "Zuletzt überprüft",
    runSearch: "Suche durchführen",
    removeFromMonitoring: "Entfernen",
    fetchError: "Fehler beim Laden überwachter Entitäten",
    searchError: "Fehler bei der Durchführung der Suche",
    errorTitle: "Fehler beim Laden der Überwachung",
    indexBuildingError: "Der Suchindex wird derzeit erstellt. Bitte versuchen Sie es in einer Minute erneut.",
    searchCadenceLabel: "Häufigkeit der automatischen Neuüberprüfung",
    cadenceDescription: "Wählen Sie aus, wie oft wir diese Namen automatisch anhand der neuesten Sanktionsdaten überprüfen sollen",
    cadence3Months: "Alle 3 Monate",
    cadence6Months: "Alle 6 Monate",
    cadence9Months: "Alle 9 Monate",
    cadence1Year: "Einmal jährlich",
    cadence2Years: "Alle 2 Jahre",
    cadenceSaved: "Häufigkeit der Neuüberprüfung gespeichert",
    saveCadenceError: "Fehler beim Speichern der Häufigkeit der Neuüberprüfung",
    filterMonitored: "Überwachte Entitäten filtern...",
    searching: "Suche...",
    noMatchingSearches: "Keine überwachten Entitäten gefunden, die Ihrem Filter entsprechen"
  },
  sidebar: {
    navigation: "Navigation",
    home: "Startseite",
    searchHistory: "Suchverlauf",
    admin: "Admin",
    adminRole: "Administrator",
    userRole: "Benutzer",
    massUpload: "Massenupload",
    monitoring: "Überwachung",
    cases: "Fälle"
  },
  history: {
    history: "Verlauf",
    viewHistory: "Suchverlauf anzeigen",
    searchHistory: "Suchverlauf",
    yourRecentSearches: "Ihre letzten Suchen über alle Sanktionslisten",
    loading: "Lade Ihren Suchverlauf...",
    loadMore: "Mehr laden",
    noSearchesYet: "Noch keine Suchen",
    searchesToAppearHere: "Ihre Suchen werden hier angezeigt, nachdem Sie nach einem Namen gesucht haben",
    recordsScanned: "Gescannte Datensätze",
    matchesFound: "Gefundene Übereinstimmungen",
    verificationId: "Verifizierungs-ID",
    sourcesChecked: "Überprüfte Quellen",
    backToHistory: "Zurück zum Verlauf",
    searchDetails: "Suchdetails",
    matchedEntities: "Übereinstimmende Entitäten",
    rerunSearch: "Neue Suche durchführen",
    runningSearch: "Suche läuft...",
    rerunResults: "Neue Suchergebnisse",
    matches: "Übereinstimmungen",
    moreMatches: "weitere Übereinstimmungen",
    noMatches: "Keine Übereinstimmungen gefunden",
    rerunError: "Fehler bei der Durchführung der Suche",
    filterSearches: "Ihren Suchverlauf filtern...",
    searching: "Suche...",
    noMatchingSearches: "Keine Suchen gefunden, die Ihrem Filter entsprechen"
  },
  user: {
    profile: "Profil",
    settings: "Einstellungen",
    account: "Konto",
    history: "Verlauf",
    language: "Sprache",
    theme: "Thema",
    notifications: "Benachrichtigungen",
    security: "Sicherheit",
    personalInfo: "Persönliche Informationen",
    changePassword: "Passwort ändern",
    twoFactor: "Zwei-Faktor-Authentifizierung",
    firstName: "Vorname",
    lastName: "Nachname",
    company: "Unternehmen",
    position: "Position",
    phoneNumber: "Telefonnummer",
    address: "Adresse",
    update: "Profil aktualisieren",
    profileUpdated: "Profil erfolgreich aktualisiert",
    oldPassword: "Altes Passwort",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    passwordChanged: "Passwort erfolgreich geändert"
  },
  massUpload: {
    title: "Massenüberprüfung",
    description: "Laden Sie mehrere Namen gleichzeitig hoch und überprüfen Sie sie gegen Sanktionslisten",
    selectFile: "CSV-Datei auswählen oder per Drag & Drop ablegen",
    loadingJobs: "Aufträge werden geladen...",
    loadingResults: "Konsolidierte Ergebnisse werden geladen...",
    loadingJobDetails: "Auftragsdetails werden geladen...",
    loadMore: "Mehr Jobs laden",
    loadingMore: "Lade weitere Jobs...",
    noJobs: "Keine Überprüfungsjobs gefunden",
    startFirstJob: "Starten Sie Ihren ersten Überprüfungsjob",
    jobId: "Job-ID",
    startScreening: "Überprüfung starten",
    resume: "Überprüfung fortsetzen",
    processing: "Verarbeitung...",
    pending: "Ausstehend",
    completed: "Abgeschlossen",
    foundMatches: "Gefundene Übereinstimmungen",
    error: "Fehler",
    progress: "Fortschritt",
    summaryTitle: "Zusammenfassung der Überprüfungsergebnisse",
    totalProcessed: "Gesamt verarbeitet",
    namesWithMatches: "Namen mit Übereinstimmungen",
    namesWithoutMatches: "Namen ohne Übereinstimmungen",
    totalMatchesFound: "Insgesamt gefundene Übereinstimmungen",
    clearAndNew: "Löschen & Neu",
    emptyStateMessage: "Laden Sie eine Datei mit Namen hoch, um mit der Stapelüberprüfung zu beginnen",
    uploading: "Datei wird hochgeladen...",
    namesLoaded: "{{count}} Namen geladen",
    name: "Name",
    status: "Status",
    matches: "Übereinstimmungen",
    verificationId: "Verifizierungs-ID",
    actions: "Aktionen",
    viewMatches: "Übereinstimmungen anzeigen",
    hideMatches: "Übereinstimmungen ausblenden",
    matchDetails: "Übereinstimmungsdetails",
    sanctionName: "Sanktionsname",
    matchPercentage: "Übereinstimmung %",
    confidenceLevel: "Vertrauensstufe",
    sources: "Quellen",
    noDetailedMatches: "Keine detaillierten Übereinstimmungsinformationen verfügbar",
    noSourceInfo: "Keine Quellinformationen",
    downloadPdf: "PDF herunterladen",
    viewFullReport: "Vollständigen Bericht anzeigen",
    jobsTitle: "Überprüfungsjobs",
    newJob: "Neuer Job",
    startTime: "Startzeit",
    namesCount: "Namen",
    matchesFound: "Gefundene Übereinstimmungen",
    view: "Anzeigen",
    viewJob: "Job-Details anzeigen",
    backToJobs: "Zurück zu Jobs",
    currentJob: "Aktueller Job",
    downloadResults: "Ergebnisse als CSV herunterladen",
    downloadSuccess: "Ergebnisse erfolgreich heruntergeladen",
    continued: "Fortgesetzt",
    completedWithErrors: "Mit Fehlern abgeschlossen",
    parentJobTitle: "Informationen zum übergeordneten Job",
    showChildJobs: "Batches anzeigen",
    hideChildJobs: "Batches ausblenden",
    totalBatches: "Gesamtzahl Batches",
    totalNames: "Gesamtzahl Namen",
    highConfidenceMatches: "Übereinstimmungen mit hoher Konfidenz",
    continuationChain: "Fortsetzungskette",
    continuationExplanation: "Dieser Job ist Teil einer Reihe von verknüpften Überprüfungsbatches. Alle Jobs in der Kette werden unten mit ihrem aktuellen Status angezeigt.",
    jobsInChain: "Jobs in dieser Kette",
    continuationInfo: "Fortsetzungsinfo",
    chainedJobs: "{{count}} Jobs in Kette",
    parentJob: "Übergeordneter Job",
    jobType: "Job-Typ",
    standardJob: "Standard-Job",
    jobPart: "Job-Teil",
    cancelJob: "Job abbrechen",
    cancelling: "Wird abgebrochen...",
    stopping: "Wird angehalten",
    stopped: "Angehalten",
    jobCancellationRequested: "Job-Abbruch angefordert. Der Job wird nach Abschluss des aktuellen Batches angehalten.",
    couldNotCancelJob: "Job konnte nicht abgebrochen werden",
    failedToCancelJob: "Fehler beim Abbrechen des Jobs",
    fileInfo: "Laden Sie eine CSV- oder TXT-Datei mit einem Namen pro Zeile hoch",
    batchSizeLimit: "Maximal 250 Namen pro Batch",
    oneJobLimit: "Nur ein aktiver Batch-Job gleichzeitig erlaubt",
    limitReached: "Monatliches Suchlimit erreicht",
    batchSizeLimitError: "Batchgrößenlimit überschritten: Ihre Datei enthält {{count}} Namen, aber das Maximum liegt bei 250. Bitte teilen Sie Ihre Daten in kleinere Batches auf oder reduzieren Sie die Anzahl der Namen in Ihrer Datei.",
    activeJobError: "Sie haben bereits einen aktiven Batch-Job. Bitte warten Sie, bis dieser abgeschlossen ist, bevor Sie einen neuen starten.",
    errorProcessingFile: "Fehler bei der Dateiverarbeitung",
    downloadSample: "Beispiel-CSV herunterladen"
  },
  sources: {
    ofac: "OFAC",
    un: "Vereinte Nationen",
    eu: "Europäische Union",
    uk: "Vereinigtes Königreich",
    interpol: "Interpol",
    fbi: "FBI",
    pep: "PEP",
    global: "Globale Sanktionen",
    treasury: "US-Finanzministerium",
    unsc: "UN-Sicherheitsrat",
    ustreas: "US-Finanzministerium",
    ustreasury: "US-Finanzministerium",
    unscr: "UN-Sicherheitsratsresolution",
    worldbank: "Weltbank",
    ecb: "Europäische Zentralbank",
    imf: "IWF",
    fsf: "Forum für Finanzstabilität",
    sanctionslist: "Sanktionsliste",
    usstate: "US-Außenministerium",
    usdept: "US-Ministerium",
    canada: "Kanada",
    australia: "Australien",
    japan: "Japan",
    osfi: "OSFI Kanada",
    bis: "Bureau of Industry and Security",
    sdnlist: "SDN-Liste",
    uktreasury: "UK-Finanzministerium",
    eucommission: "EU-Kommission",
    nsa: "National Security Agency",
    nationalsecurity: "Nationale Sicherheit",
    globalsanctions: "Globale Sanktionen",
    sanctionsprogram: "Sanktionsprogramm",
    debarredparties: "Ausgeschlossene Parteien",
    deniedpersons: "Abgelehnte Personen",
    entitylist: "Entitätsliste"
  },
  cases: {
    title: "Fallmanagement",
    loading: "Lade Fälle...",
    errorFetching: "Fehler beim Laden der Fälle",
    noCases: "Keine Fälle gefunden",
    totalCases: "Gesamtzahl Fälle",
    openCases: "Offene Fälle",
    allOpenCases: "Alle offenen",
    inProgressCases: "In Bearbeitung",
    completedCases: "Abgeschlossen",
    matches: "Übereinstimmungen",
    reviewed: "Überprüft",
    minute: "Minute",
    minutes: "Minuten",
    hour: "Stunde",
    hours: "Stunden",
    day: "Tag",
    days: "Tage",
    ago: "vor",
    statusPending: "Ausstehend",
    statusInProgress: "In Bearbeitung",
    statusCompleted: "Abgeschlossen",
    refresh: "Aktualisieren",
    filters: {
      all: "Alle",
      allOpen: "Alle offenen",
      pending: "Ausstehend",
      inProgress: "In Bearbeitung",
      completed: "Abgeschlossen"
    },
    report: {
      downloadButton: "Bericht herunterladen",
      tooltip: "Der Fallbericht kann erst heruntergeladen werden, wenn alle potenziellen Übereinstimmungen überprüft wurden.",
      loading: "Bericht wird generiert...",
      error: "Fehler beim Generieren des Berichts",
      caseCompleted: "Fall abgeschlossen",
      casePending: "Fall muss vollständig überprüft werden, um den Bericht herunterzuladen",
      matchesConfirmed: "Sanktionsübereinstimmungen bestätigt",
      noMatchesConfirmed: "Keine Sanktionsübereinstimmungen",
      reviewedBy: "Überprüft von",
      caseSummary: "Fallzusammenfassung",
      confirmedMatches: "bestätigte Übereinstimmungen",
      allMatchesCleared: "Alle Übereinstimmungen freigegeben",
      statusUnknown: "Status unbekannt"
    }
  },
  cookies: {
    consent: "Diese Website verwendet Cookies, um die Benutzererfahrung zu verbessern.",
    accept: "Akzeptieren",
    deny: "Ablehnen",
    privacyPolicy: "Datenschutzrichtlinie"
  },
  pastdue: {
    banner: "Ihre Zahlung ist {{days}} Tage überfällig. Bitte aktualisieren Sie Ihre Zahlungsinformationen.",
    resolve: "Zahlungsmethode aktualisieren",
    modal: {
      title: "Zahlung überfällig",
      message: "Ihre Abonnementzahlung ist überfällig. Sie können die App erst nutzen, wenn Ihre Zahlung abgewickelt ist.",
      button: "Zahlungsmethode aktualisieren"
    }
  },
  trial: {
    banner: "Ihre kostenlose Testversion läuft in {{days}} Tagen ab. Aktualisieren Sie, um weiterhin alle Funktionen nutzen zu können.",
    daysRemaining: "{{days}} Tage verbleibend",
    status: "TESTVERSION",
    upgrade: "Jetzt zur Vollversion wechseln",
    activeTitle: "Kostenlose Testversion Aktiv",
    description: "Sie nutzen derzeit den vollen Zugang zu allen professionellen Funktionen während Ihrer kostenlosen Testphase.",
    upgradePrompt: "Wechseln Sie zu einem kostenpflichtigen Plan, bevor Ihre Testversion endet, um weiterhin alle Funktionen nutzen zu können."
  },
  pricing: {
    choose_plan: "Wählen Sie Ihren Plan",
    upgrade_plan: "Plan Upgraden",
    restart_subscription: "Abonnement Neu Starten",
    subtitle: "Schöpfen Sie die volle Kraft des Sanktions-Screenings aus",
    monthly: "Monatlich",
    yearly: "Jährlich",
    billed_annually: "jährlich abgerechnet",
    save: "Sparen",
    most_popular: "Am Beliebtesten",
    recommended: "Empfohlen",
    
    starter: "Starter",
    professional: "Professionell",
    enterprise: "Enterprise",
    custom: "Individuell",
    
    searches_100: "100 Suchen pro Monat",
    searches_500: "500 Suchen pro Monat",
      searches_1000: "Bis zu 100 Suchen pro Monat",
  searches_10000: "Bis zu 1.000 Suchen pro Monat",
    unlimited_searches: "Unbegrenzte Suchen",
    
    basic_support: "Basis-Kundensupport",
    priority_support: "Prioritäts-Kundensupport",
    dedicated_support: "Dedizierter Account Manager",
    
    email_notifications: "E-Mail-Benachrichtigungen",
    advanced_notifications: "Erweiterte Benachrichtigungen",
    
    basic_dashboard: "Basis-Dashboard",
    detailed_reports: "Detaillierte Berichte",
    
    api_access: "API-Zugang",
    rest_api_access: "REST API-Zugang",
    bulk_screening: "Massen-Screening",
    batch_screening: "Batch-Screening",
    team_members_3: "3 Teammitglieder",
    team_members_10: "10 Teammitglieder",
    active_monitoring: "Aktive Überwachung",
    case_management: "Fallmanagement",
    custom_integrations: "Benutzerdefinierte Integrationen",
    white_label: "White-Label-Lösung",
    sla: "SLA-Garantie",
    on_premise: "On-Premise-Bereitstellungsoption",
    
    get_started: "Loslegen",
    upgrade_now: "Jetzt Upgraden",
    contact_sales: "Vertrieb Kontaktieren"
  }
};

export default de;